import { canv } from '@/canv/global.js'
import { WIDTH_MULTIPLIER_FOR_HIGHLIGHTER } from '../../constants';

export const checkIntersectionSketchAndMouseLine = (sketch) => {
    const pt = canv.actionManager.getActionPoint();
    const ppt = canv.actionManager.getPreActionPoint();

    for (let i = 1; i < sketch.points.length; i++) {
        const step = 1 / 100;
        const p = sketch.points[i],
                cp = sketch.cpoints[i],
                cpp = sketch.cpoints[i - 1];

        if (cp === undefined || cpp === undefined) {
            continue;
        }

        for (let t = 0; t < 1; t += step) {
            const prevPoint = sketch.getBezierPoint(sketch.points[i-1]['x'], sketch.points[i-1]['y'], cpp.cn[0], cpp.cn[1], cp.cp[0], cp.cp[1], p['x'], p['y'], t - step);
            const point = sketch.getBezierPoint(sketch.points[i-1]['x'], sketch.points[i-1]['y'], cpp.cn[0], cpp.cn[1], cp.cp[0], cp.cp[1], p['x'], p['y'], t);

            const x1 = prevPoint['x'];
            const y1 = prevPoint['y'];
            const x2 = point['x'];
            const y2 = point['y'];
            const x3 = ppt['x'];
            const y3 = ppt['y'];
            const x4 = pt['x'];
            const y4 = pt['y'];

            if (!isNaN(x1) && !isNaN(y1) && !isNaN(x2) && !isNaN(y2)) {
                const denom = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1);

                if (denom === 0) {
                    continue;
                }

                const ua = ((x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)) / denom;
                const ub = ((x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3)) / denom;

                if (ua >= 0 && ua <= 1 && ub >= 0 && ub <= 1) {
                    return true;
                }
            }
        }
    }

    return false;
}

const CURSOR_SIZE = 8;

export const checkClickOnSketch = (sketch) => {
    const pt = canv.actionManager.getActionPoint();
    const eraserSize = canv.actionManager.getZoomConstant(CURSOR_SIZE);

    const lineWidth = sketch.lineWidth * (sketch.mode === 'pen' ? 1 : WIDTH_MULTIPLIER_FOR_HIGHLIGHTER);
    const area = {
        'x': pt['x'] + eraserSize / 2,
        'y': pt['y'] + eraserSize * 1.5,
        'radius': lineWidth / 2 + eraserSize / 2,
    };

    return sketch.isInCircleArea(area);
}

export const handleDeleteGroup = (group) => {
    if (!group) return;

    canv.eventManager.openRecord();
    canv.canvasController.deleteProcessor(group);
    canv.eventManager.closeRecord();
}
